import { render, staticRenderFns } from "./nda.vue?vue&type=template&id=18aafa25&scoped=true"
import script from "./nda.vue?vue&type=script&lang=js"
export * from "./nda.vue?vue&type=script&lang=js"
import style0 from "./document.scss?vue&type=style&index=0&id=18aafa25&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aafa25",
  null
  
)

export default component.exports